import { Tooltip, Typography } from 'antd'
import CIMSBadge from 'components/CIMSBadge'
import { StrengthCountProps } from './types'
import { CheckCircleTwoTone } from '@ant-design/icons'

const StrengthCount: React.FC<StrengthCountProps> = ({ count, max }) => {
  if (typeof count !== 'number')
    return (
      <Typography.Text type="secondary">
        No strength ages assigned
      </Typography.Text>
    )
  else if (count < max)
    return (
      <Tooltip title="Strength values remaining">
        {/* var(--ant-warning-color) */}
        <CIMSBadge backgroundColor="#faad14" count={max - count} />
      </Tooltip>
    )
  else
    return (
      <Tooltip title="All strength values have been assigned">
        {/* var(--ant-success-color) */}
        <CheckCircleTwoTone twoToneColor="#52c41a" style={{ fontSize: 20 }} />
      </Tooltip>
    )
}

export default StrengthCount
